// schema/marks/color.ts
var COLOR_SCHEMA = () => ({
  attrs: {
    color: { default: null }
  },
  parseDOM: [
    {
      style: "color",
      getAttrs: (value) => ({ color: value })
    }
  ],
  toDOM: (mark) => {
    const { color } = mark.attrs;
    return ["span", { style: `color: ${color}` }, 0];
  }
});
var COLOR_KEY = "color";
var COLOR = {
  [COLOR_KEY]: COLOR_SCHEMA
};
export {
  COLOR,
  COLOR_KEY,
  COLOR_SCHEMA
};
